import { SkeletonLoader } from '@/components/SkeletonLoader';

export default function CoworkingProductSkeleton() {
  return (
    <div className="flex flex-col gap-5">
      <SkeletonLoader className="hidden min-[700px]:block w-64 h-10" />
      <div className="flex flex-col gap-5 min-[700px]:flex-row flex-nowrap">
        <SkeletonLoader className="w-full h-[180px] min-[700px]:w-[150px] min-[700px]:h-[100px] flex-shrink-0" />

        <SkeletonLoader className="min-[700px]:hidden w-32 h-10" />

        <div className="flex flex-col flex-grow gap-2 h-[100px]">
          <SkeletonLoader className="w-64 h-full" />
          <SkeletonLoader className="w-64 h-full" />
          <SkeletonLoader className="w-64 h-full" />
        </div>

        <div className="flex flex-row justify-end items-center gap-2 min-[700px]:justify-center min-[700px]:flex-col whitespace-nowrap">
          <SkeletonLoader className="w-32 h-8 rounded-full" />
        </div>
      </div>
    </div>
  );
}
